var render, staticRenderFns
import script from "./InnerNewsRenderBlock.vue?vue&type=script&lang=js&"
export * from "./InnerNewsRenderBlock.vue?vue&type=script&lang=js&"
import style0 from "./InnerNewsRenderBlock.vue?vue&type=style&index=0&id=09b3b78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3b78e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b3b78e')) {
      api.createRecord('09b3b78e', component.options)
    } else {
      api.reload('09b3b78e', component.options)
    }
    
  }
}
component.options.__file = "src/components/blocks/render/InnerNewsRenderBlock.vue"
export default component.exports